import type { CentrifugeMessage } from '../messageTypes';

export interface FanInMessageUnparsed {
  data: { type: 'FanIn'; message: string; created_at?: number };
  seq?: undefined;
  gen?: undefined;
  offset: number;
}

export interface FanInMessage {
  data: { type: 'FanIn'; message: { nick: string }; created_at?: number };
  seq?: undefined;
  gen?: undefined;
  offset: number;
  key?: string;
}

export interface VipInMessage {
  data: { type: 'VipIn'; message: { nick: string }; created_at?: number };
  seq?: undefined;
  gen?: undefined;
  offset: number;
  key?: string;
}

export interface KingFanInMessage {
  data: { type: 'KingFanIn'; message: { nick: string }; created_at?: number };
  offset: number;
}

export interface ManagerInMessage {
  data: {
    type: 'ManagerIn';
    message: {
      nick: string;
    };
    created_at?: number;
  };
  offset: number;
}

export const isFanInMessage = (item: CentrifugeMessage): item is FanInMessage => {
  return 'data' in item && item.data.type === 'FanIn';
};

export const isVIPFanInMessage = (item: CentrifugeMessage): item is VipInMessage => {
  return 'data' in item && item.data.type === 'VipIn';
};

export const isKingFanInMessage = (item: CentrifugeMessage): item is KingFanInMessage => {
  return 'data' in item && item.data.type === 'KingFanIn';
};

export const isManagerInMessage = (item: CentrifugeMessage): item is ManagerInMessage => {
  return 'data' in item && item.data.type === 'ManagerIn';
};
